/**
 * 방 수명 정책 — **단일 출처**.
 * 초대코드(KV TTL)와 방 무활동 정리(DO alarm)가 같은 값을 쓰고,
 * 대기 화면 안내 문구도 여기서 가져다 쓴다. 값을 바꾸면 세 곳이 함께 바뀐다.
 */
export const ROOM_TTL_MIN = 30;
export const ROOM_TTL_SEC = ROOM_TTL_MIN * 60;
export const ROOM_TTL_MS = ROOM_TTL_SEC * 1000;

/** 대기 화면 안내용 문구 (예: "30분") */
export const ROOM_TTL_LABEL = `${ROOM_TTL_MIN}분`;

/**
 * 초대코드 길이 — 서버가 발급하고(genInviteCode) 웹 입력칸이 같은 길이로 제한한다.
 * 어긋나면 "코드를 다 넣었는데 입장 버튼이 안 열리는" 상황이 생기므로 여기서만 정의.
 */
export const INVITE_CODE_LEN = 6;

/**
 * 방 WebSocket 유지 정책 — **단일 출처**.
 *
 * 방은 카드를 뽑기 전까지 오가는 메시지가 없다. 그 사이 소켓이 완전히 조용하면
 * 이동통신 NAT·중간 프록시가 유휴 TCP 연결을 끊어버린다(휴대폰에서 카카오톡 등으로
 * 잠깐 나갔다 오면 연결이 죽어 있는 이유). 그래서 주기적으로 ping을 보내 살려 둔다.
 *
 * ⚠️ ping은 **활동이 아니다.** 서버(RoomDO)는 ping에 무활동 타이머를 갱신하지 않는다 —
 * 갱신하면 탭만 열어둬도 방이 영원히 안 지워진다.
 */
export const WS_PING_INTERVAL_MS = 20_000;

/**
 * ping을 보내고 pong을 기다리는 한계. 모바일에서는 소켓이 실제로는 죽었는데도
 * readyState가 OPEN으로 남는 경우가 흔하다(half-open). 이 시간 안에 pong이 없으면
 * 죽은 것으로 보고 끊고 다시 붙는다.
 */
export const WS_PONG_TIMEOUT_MS = 8_000;

/** 재연결 백오프: 첫 시도 간격 → 최대 간격까지 2배씩. 이 횟수를 다 쓰면 사용자에게 알린다 */
export const WS_RECONNECT_BASE_MS = 600;
export const WS_RECONNECT_MAX_MS = 8_000;
export const WS_RECONNECT_MAX_TRIES = 8;

/**
 * 재촉 벨 쿨다운 — (보낸 사람 → 대상) 쌍 기준.
 * 서버(RoomDO)가 실제로 차단하고, 웹은 같은 값으로 버튼을 비활성화한다.
 * 두 값이 어긋나면 "눌렀는데 거부당하는" 어긋난 UX가 되므로 반드시 여기서만 정의.
 */
export const NUDGE_COOLDOWN_MS = 5000;
